var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { x4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fecha.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fecha.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.fecha, "value", $$v)
                                  },
                                  expression: "formFields.fecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.requerimiento.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.requerimiento.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.requerimiento,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.requerimiento.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.adp.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.adp.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.adp, "value", $$v)
                                  },
                                  expression: "formFields.adp.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.rut_cliente.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.rut_cliente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.rut_cliente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.rut_cliente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.cliente.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.cliente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cliente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.cliente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.flota.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.flota.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.flota, "value", $$v)
                                  },
                                  expression: "formFields.flota.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }